import { makeAutoObservable } from 'mobx'

export class ModalController {
  /**
   * @type {ModalController}
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new ModalController()
    }
    return this.instance
  }

  showModal = false
  addedModules = []
  constructor() {
    makeAutoObservable(this)
  }

  show(modules) {
    this.addedModules.replace(modules)
    this.showModal = true
  }

  closeModal() {
    this.showModal = false
  }
}
